import classNames from "classnames"
import { renderRichText } from "gatsby-source-storyblok"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getTextColorClass } from "@utils/V2/color"
import React, { useMemo } from "react"

const linkTextColor = getTextColorClass(Color.Blue)

type Props = {
  id?: string
  headerText?: string
  content: Storyblok.StoryblokRichtextContent
}

const ArticleParagraph = ({ id, headerText, content, ...props }: Props) => {
  const renderedRichText = useMemo(
    () => ({
      __html: renderRichText(content) ?? "",
    }),
    [content]
  )

  return (
    <div id={id} className="pt-[30px]" {...props}>
      {headerText ? (
        <Typography
          className="mb-lg"
          element="h4"
          size="lead-lg"
          font="grotesk"
          weight="medium"
          color={Color.Charcoal}
          text={headerText}
        />
      ) : null}
      <div
        className={classNames(
          "[&_a]:underline [&_a]:decoration-current [&_li]:ml-16 [&_li_p]:pb-0 [&_ol]:list-decimal [&_ol]:space-y-[5px] [&_ol]:!pl-0 [&_ol]:pb-24 [&_p]:!mb-0 [&_p]:pb-24 [&_ul]:list-disc [&_ul]:space-y-[5px] [&_ul]:!pl-0 [&_ul]:pb-24 [&_ul_li::marker]:content-arrow",
          getTextColorClass(Color.Charcoal),
          `[&_a]:!${linkTextColor}`
        )}
        dangerouslySetInnerHTML={renderedRichText}
      />
    </div>
  )
}

export default ArticleParagraph
